/**
 * مقصد بازگشت بعد از ورود.
 *
 * مقصد در کوئری (`?next=`) حمل می‌شود نه فقط در `location.state`، چون لینک‌های
 * لندینگ از پیامک و شبکه‌های اجتماعی باز می‌شوند و کاربر ممکن است صفحه را رفرش
 * کند یا لینک را فوروارد کند — در آن حالت state از بین می‌رود ولی کوئری نه.
 */

export const DEFAULT_AFTER_LOGIN_PATH = '/dashboard';

/**
 * فقط مسیرهای داخلی پذیرفته می‌شوند.
 * `//host` و `https://host` و `javascript:` رد می‌شوند تا لینک ورود
 * به ابزار هدایت کاربر به سایت دیگری تبدیل نشود.
 */
export function sanitizeNextPath(raw: string | null | undefined): string | null {
  if (!raw) return null;

  let value = String(raw).trim();
  if (!value) return null;

  // لینک‌هایی که یک بار انکد شده‌اند و مستقیم داخل کوئری نشسته‌اند
  try {
    if (value.includes('%2F') || value.includes('%3F')) {
      value = decodeURIComponent(value);
    }
  } catch {
    return null;
  }

  if (!value.startsWith('/')) return null;
  if (value.startsWith('//')) return null;
  if (value.startsWith('/\\')) return null;

  // فاصله و کاراکترهای کنترلی می‌توانند بررسی‌های بالا را دور بزنند
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    if (code <= 0x20 || code === 0x7f) return null;
  }

  // بازگشت به خود صفحهٔ ورود حلقه می‌سازد
  if (value.startsWith('/login') || value.startsWith('/register')) return null;

  return value;
}

/** مسیر ورود با حفظ مقصد بازگشت */
export function buildLoginUrl(nextPath?: string | null, mode?: 'register'): string {
  const params = new URLSearchParams();
  if (mode) params.set('mode', mode);
  const safe = sanitizeNextPath(nextPath);
  if (safe) params.set('next', safe);
  const query = params.toString();
  return query ? `/login?${query}` : '/login';
}

/** مسیر فعلی مرورگر به شکلی که برای `next` قابل استفاده باشد */
export function currentPathForNext(location: { pathname: string; search?: string }): string {
  return `${location.pathname}${location.search || ''}`;
}
